import { clamp, FONT_LIMITS } from "./logic";

interface FontControlProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
}

/** Par de botões A- / A+ para o tamanho da fonte de um bloco de texto. */
export default function FontControl({ label, value, onChange }: FontControlProps) {
  return (
    <div className="qz-font-row">
      <span>{label}</span>
      <div className="qz-font-btns">
        <button
          type="button"
          aria-label={`Diminuir fonte de ${label.toLowerCase()}`}
          disabled={value <= FONT_LIMITS.min}
          onClick={() => onChange(clamp(value - FONT_LIMITS.step, FONT_LIMITS.min, FONT_LIMITS.max))}
        >
          A-
        </button>
        <output className="qz-font-value" aria-label={`Tamanho atual: ${value} pixels`}>
          {value}px
        </output>
        <button
          type="button"
          aria-label={`Aumentar fonte de ${label.toLowerCase()}`}
          disabled={value >= FONT_LIMITS.max}
          onClick={() => onChange(clamp(value + FONT_LIMITS.step, FONT_LIMITS.min, FONT_LIMITS.max))}
        >
          A+
        </button>
      </div>
    </div>
  );
}
